import React from 'react';
import importSectionStyles from '../../ImportSection.styles';

const SageIntacctInstruction = () => {
    return (
            <div style={importSectionStyles.instructionCard}>
                <strong style={importSectionStyles.title}>Sage Intacct Instructions</strong>
                <ul style={importSectionStyles.instructions}>
                    <li>1. Pull your 1099 Report from Sage Intacct. To do this, go to "Accounts Payable" then click on "1096/1099" under "Reports." Then you will see the option "1099, Create file", Select this option.</li>
                    <li>2. Select the Export drop-down menu on the upper right and choose CSV. (Note: Must select CSV, other options will not work)</li>
                    <li>3. Open the CSV file to check your information. If needed, delete the first few rows in the CSV file so that row 1 contains the report headers. Row1, columns A through I, should look like this:</li>
                    <li>4. Select a Tax Year and a Form from the drop-down menus below.</li>
                    <li>5. Click "Select files..." to upload the CSV file. Once it has been uploaded, hit "Next" to proceed.</li>
                </ul>
            </div>
    );
};

export default SageIntacctInstruction;

